import { useEffect } from "react"
import { X, Info } from "lucide-react"

const ScreenShareTooltip = ({ isVisible, onClose }) => {
  // Auto-hide tooltip after 3 seconds
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose()
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [isVisible, onClose])

  if (!isVisible) return null

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 max-w-sm w-full px-4">
      <div className="bg-gray-800 rounded-lg shadow-lg border border-gray-700 p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0 bg-blue-500 rounded-full p-1">
            <Info size={16} className="text-white" />
          </div>

          <div className="ml-3 flex-1">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium text-white">
                Screen Sharing Active
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-white"
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScreenShareTooltip
